/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signing_Filter_CompletedInputs */

const cs_signing_filter_completed = /** @type {(inputs: Signing_Filter_CompletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dokončeno`)
};

const en_signing_filter_completed = /** @type {(inputs: Signing_Filter_CompletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Completed`)
};

/**
* | output |
* | --- |
* | "Completed" |
*
* @param {Signing_Filter_CompletedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const signing_filter_completed = /** @type {((inputs?: Signing_Filter_CompletedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signing_Filter_CompletedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_signing_filter_completed(inputs)
	return cs_signing_filter_completed(inputs)
});